<template>
  <div class="container pageAuth">
    <div class="main-container-header">
      <div class="main-container-header__title">
        <img
            height="32"
            width="32"
            :src="require('@/assets/images/icon-register.svg')"
        />
        <h2>Register</h2>
      </div>
    </div>
    <div class="row">
      <div class="m-auto">
        <div id="register-panel" class="panel panel-default">
          <div class="panel-body">
            <form
                class="form-signin"
                method="POST"
                @submit.prevent="
                reset();
                submit();
              "
            >
              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Agency Manager Email</label>
                <input
                    v-model="form.email"
                    maxlength="255"
                    @blur="onEmailBlur"
                    type="email"
                    class="form-control"
                    placeholder="Your email here"
                />
                <div v-if="error.email" class="mt-1 text-danger ">
                  Email: {{error.email}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Username</label>
                <input
                    v-model="form.username"
                    maxlength="40"
                    type="text"
                    class="form-control"
                    placeholder="Inferred from email"
                    v-trim
                />
                <div v-if="error.username" class="mt-1 text-danger ">
                  Username: {{error.username}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Agency ID</label>
                <input
                    v-model="form.agency"
                    maxlength="40"
                    type="text"
                    class="form-control readonly"
                    readonly
                    placeholder="Inferred from email"
                />
                <div v-if="error.agency" class="mt-1 text-danger ">
                  Agency ID: {{error.agency}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Company Name</label>
                <input
                    v-model="form.company_name"
                    maxlength="255"
                    type="text"
                    class="form-control"
                    placeholder="Use legal name"
                />
                <div v-if="error.company_name" class="mt-1 text-danger ">
                  Company Name: {{error.company_name}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Agency Address</label>
                <input
                    v-model="form.address"
                    maxlength="255"
                    type="text"
                    class="form-control"
                    placeholder="Street, number"
                />
                <div v-if="error.address" class="mt-1 text-danger ">
                  Agency Address: {{error.address}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Country</label>
                <select
                    v-model="form.country_code"
                    class="form-control ">
                  <option value="">Select country ...</option>
                  <option :key="code" v-for="(country, code) in countries"
                          :value="code">{{ country }}
                  </option>
                </select>
                <div v-if="error.country_code" class="mt-1 text-danger ">
                  Country: {{error.country_code}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Zip code</label>
                <input
                    v-model="form.postal_code"
                    maxlength="10"
                    type="text"
                    class="form-control"
                    placeholder="Use a valid postal code"
                />
                <div v-if="error.postal_code" class="mt-1 text-danger ">
                  Zip Code: {{error.postal_code}}
                </div>
              </div>

              <div class="form-group">
                <label><span class="text-danger"><b>*</b></span> Phone</label>
                <input
                    v-model="form.phone"
                    maxlength="20"
                    class="form-control"
                    placeholder='Include country code "+XX"'
                />
                <div v-if="error.phone" class="mt-1 text-danger">
                  Phone: {{error.phone}}
                </div>
              </div>

              <div class="form-group">
                <label>IATA/TIDS code</label>
                <input
                    v-model="form.iata_number"
                    maxlength="10"
                    class="form-control"
                    placeholder="Use a valid IATA/TIDS code"
                />
              </div>

              <div v-if="error && (typeof error === 'string' || (typeof error === 'object' && error.summary))"
                   class="error-summary mt-4">
                <div v-if="typeof error === 'string'" class="alert alert-danger">
                  {{ error }}
                </div>

                <div v-if="typeof error === 'object' && error.summary" class="alert alert-danger">
                  {{ error.summary }}
                </div>
              </div>

              <div class="form-group form-action">
                <button class="btn btn-primary" type="submit">
                  Create new account
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/services/axios";
import helpers from "../../mixins/helpers";
import data from "@/services/data";
import TrimDirective from "@/directives/trim-directive";

export default {
  directives: {
    trim: TrimDirective
  },
  data: function () {
    return {
      form: {
        country_code: '',
      },
      error: {},
      submitted: false,
      signupFields: []
    };
  },
  mixins: [helpers],
  components: {},
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      if (!this.isShowSignup) {
        window.location.href = "/";
        return
      }
    },
    reset: function () {
      this.error = {};
    },
    submit: function () {
      axios.post("/agent/register-agency", this.form).then(res => {
        let result = res.data;
        this.submitted = true;
        if (result.error) {
          this.error = result.error;
        } else {
          this.$localStorage.set('logged', true);
          this.$localStorage.set('token', result.data.token);
          this.$localStorage.set('role', result.data.role);
          this.$localStorage.set('isConsumerOwner', result.data.is_consumer_owner);
          this.$localStorage.set('email', result.data.email);
          window.location.href = "/";
        }
      }).catch(err => {
        if (err.response && err.response.data && err.response.data.error) {
          this.error = err.response.data.error;
        } else {
          this.error = "An error occurred during agency registration.";
        }
      });
    },
    onEmailBlur: function ($event) {
      let email = $event.target.value;

      if (email.includes('@')) {
        let items = email.split("@");
        let username = items[0];

        if (items.length > 1) {
          let agencyItems = items[1].split(".");

          if (agencyItems.length > 0) {
            let agency = agencyItems[0];

            this.form.username = username.toLowerCase().substr(0, 40).replace(/[^a-zA-Z0-9_.-]+/ig, '');
            this.form.agency = agency.toLowerCase().substr(0, 40);

            this.$forceUpdate();
            return;
          }
        }
      }
      this.form.username = '';
      this.form.agency = '';
      this.$forceUpdate();
    }
  },
  computed: {
    countries() {
      return data.countries
    },
    isShowSignup() {
      return process.env.VUE_APP_SHOW_SIGNUP === 'true'
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .container {
    &.pageAuth {
      max-width: 600px;

      p {
        font-size: 1.1rem;
        font-weight: 300;

        &.forgotLink {
          margin: 0;

          a {
            font-size: 1rem;
            font-weight: 500;
          }
        }
      }

      form {
        position: relative;

        label {
          font-size: 1.2rem;
          color: #000000;
          margin-top: 0.7rem;
          margin-bottom: 0.3rem;
        }
      }

      .formMainAction {
        margin-top: 2rem;


      }

      .form-group {
        margin-bottom: 0.5rem;

        input {
          &:read-only {
            background-color: #f0f0f0;
            color: #b0b0b0;
          }
        }
      }

      .form-action {
        margin-top: 2rem;
      }

      .form-control {
        border: 1px solid #e0e0e0;
        height: calc(3rem + 2px);
        background-color: white;

        &:focus {
          background-color: white;
          border: 2px solid #606060;
        }

        &.readonly {
          &:focus {
            background-color: #f0f0f0;
            border: none;
          }
        }
      }
    }
  }

  #register-panel {
    width: calc(600px - 2rem);
    border: 1px solid #d9e4f3;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    margin-top: 0;
  }
}
</style>
